module.exports = __webpack_public_path__ + "media/online_university/safe-learning@2x-9e1b340d.png";